export const LANDLORD_DOES_NOT_KNOW_VALUE = 'landlordDoesNotKnow';

const CERTIFICATE_UNAVAILABLE_VALUES = [
  'inProgress',
  'requestedToLandlord',
  LANDLORD_DOES_NOT_KNOW_VALUE
];

export const certificateIsUnavailable = certificateValue =>
  CERTIFICATE_UNAVAILABLE_VALUES.includes(certificateValue) ||
  !certificateValue;

export const getUnavailableCopy = (certificateValue, trans) =>
  certificateValue === LANDLORD_DOES_NOT_KNOW_VALUE
    ? trans('listing.energy-certificate.landlord-does-not-know')
    : trans('listing.energy-certificate.requested-to-landlord');

export default {
  certificateIsUnavailable
};
